import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-not-available-installment-dialog',
  templateUrl: './not-available-installment-dialog.component.html',
  styleUrls: ['./not-available-installment-dialog.component.scss']
})
export class NotAvailableInstallmentDialogComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
